import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
import { Link } from 'react-router-dom';
export function PartnersPage() {
  return <div className="bg-white" data-id="element-551">
      <PageHero title="Our Partners" subtitle="Collaborating with industry leaders to elevate our offerings." data-id="element-552" />

      {/* Strategic Partners */}
      <section className="py-24 md:py-32 border-b border-brand-dark/10" data-id="element-553">
        <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-554">
          <div className="text-center mb-16" data-id="element-555">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-dark mb-6" data-id="element-556">
              Strategic Partners
            </h2>
            <div className="w-12 h-1 bg-brand-gold mx-auto" data-id="element-557"></div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 items-center opacity-60 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-558">
            {/* Placeholder Logos */}
            {[1, 2, 3, 4].map(i => <motion.div key={i} className="aspect-video bg-brand-gray/20 flex items-center justify-center rounded-sm" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} data-id="element-559">
                <span className="font-serif text-brand-dark/50 text-xl" data-id="element-560">
                  Partner {i}
                </span>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Location Partners */}
      <section className="py-24 md:py-32 bg-brand-dark text-white relative" data-id="element-561">
        <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-562"></div>
        <div className="max-w-6xl mx-auto px-6 md:px-12 relative z-10" data-id="element-563">
          <div className="text-center mb-16" data-id="element-564">
            <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-565">
              Location Partners
            </h2>
            <div className="w-12 h-1 bg-brand-red mx-auto" data-id="element-566"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-567">
            {[{
            name: 'Downtown Plaza',
            bio: 'Hosting our flagship restaurant in the heart of the financial district.'
          }, {
            name: 'The Grand Hotel',
            bio: 'Exclusive catering partner for their premium event spaces.'
          }, {
            name: 'Westside Market',
            bio: 'Home to our first Grab & Go concept kiosk.'
          }].map((partner, idx) => <motion.div key={idx} className="border border-white/10 p-8 hover:bg-white/5 transition-colors" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} data-id="element-568">
                <h3 className="text-2xl font-serif text-brand-gold mb-4" data-id="element-569">
                  {partner.name}
                </h3>
                <p className="text-white/70 font-light" data-id="element-570">{partner.bio}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Philanthropy */}
      <section className="py-24 md:py-32 bg-brand-beige" data-id="element-571">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-572">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-dark mb-6" data-id="element-573">
            Philanthropy & Charity
          </h2>
          <div className="w-12 h-1 bg-brand-terracotta mx-auto mb-10" data-id="element-574"></div>
          <p className="text-lg text-brand-dark/80 font-light leading-relaxed mb-12" data-id="element-575">
            We believe in giving back to the communities that support us. JJ
            Group proudly collaborates with local food banks, culinary education
            programs, and community development initiatives.
          </p>
          <Link to="/company/about" className="inline-block border border-brand-dark text-brand-dark px-8 py-3 text-sm uppercase tracking-[0.2em] hover:bg-brand-dark hover:text-white transition-colors" data-id="element-576">
            Learn About Our Impact
          </Link>
        </div>
      </section>
    </div>;
}